import { Injectable } from '@angular/core';
import { ProfileService } from '@data/services/profile.service';
import { User } from '@data/models/index';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private dataSource = new BehaviorSubject<User>(new User());
  User = this.dataSource.asObservable();
  user$: Observable<User> = this.dataSource.asObservable();
  constructor(private profile: ProfileService) { }

  updatedDataSelection(data: User) {
    this.dataSource.next(data);
  }
/**
 * This function used to set the token and user details using localStorage service.
 * @author Balakrishnan Rajendran, on Apr 29, 2020
 */
  setToken(tokenObj) {
    localStorage.setItem('token', tokenObj.userdetails.token);
    let newProfileData = tokenObj.userdetails.userObj;
    newProfileData["UID"] = tokenObj.userdetails.loginObj.UID;
    newProfileData["photoURL"] = tokenObj.userdetails.loginObj.photoURL;
    newProfileData["thumbnailURL"] = tokenObj.userdetails.loginObj.thumbnailURL;
   
    localStorage.setItem('profile', JSON.stringify(tokenObj.userdetails.userObj));
    localStorage.setItem('session', JSON.stringify(tokenObj.userdetails.loginObj));
    if (tokenObj.userdetails.missionaryGAUId) {
      if (tokenObj.userdetails.missionaryGAUId == 'Finance') {
        localStorage.setItem('isMissionaryUser', JSON.stringify(false));
        localStorage.setItem('isFinanceUser', JSON.stringify(true));
      } else {
        localStorage.setItem('isMissionaryUser', JSON.stringify(true));
      }
    } else {
      localStorage.setItem('isMissionaryUser', JSON.stringify(false));
    }
    localStorage.setItem('missionaryGAUId', JSON.stringify(tokenObj.userdetails.missionaryGAUId));
    if (tokenObj.userdetails.missionaryGAUId == 'HQ') {
      localStorage.setItem('isHQUser', JSON.stringify(true));
    //  localStorage.setItem('missionaryGAUId', JSON.stringify('502'));
      localStorage.setItem('isMissionaryUser', JSON.stringify(false));
    }
    if (tokenObj.userdetails.isHQUser) {
      localStorage.setItem('isHQUser', JSON.stringify(true));
      localStorage.setItem('isMissionaryUser', JSON.stringify(false));
    } else {
      localStorage.setItem('isHQUser', JSON.stringify(false));
    }
    localStorage.setItem('isGAUEditor', JSON.stringify(tokenObj.userdetails.isGAUEditor));
  
    this.profile.currentProfile.token = tokenObj.userdetails.token;
    this.profile.currentProfile.username = tokenObj.userdetails.userObj.FirstName;
    this.profile.currentProfile.isMissionaryUser = tokenObj.userdetails.isMissionaryUser;
    let userDetails: any = this.setAfterLoginData(tokenObj.userdetails.userObj, tokenObj.userdetails.loginObj);
    this.profile.userDetails = userDetails;
    const currentUser = JSON.parse(localStorage.getItem('profile'));
    const data = {
      contactId: currentUser.Id,
      email: currentUser.Email,
      firstName: currentUser.FirstName,
      lastName: currentUser.LastName,
      phone: currentUser.MobilePhone
    }
    this.profile.fetchOrCreateUserId(data).subscribe((result: any) => {
        if (result) {
          localStorage.setItem('userId', result.userId);
          const userData = {
            token: tokenObj.userdetails.token, isMissionaryUser: tokenObj.userdetails.isMissionaryUser,
            username: tokenObj.userdetails.userObj.FirstName, password: '', userId: result.userId
          };
          this.profile.profileUpdate();
          this.updatedDataSelection(userData);
        }
      }, (error: HttpErrorResponse) => {
        console.log('Error:', error);
        });
  }

  /**
   * This function used to remove the local storage details set the token and user details using localStorage service.
   * @author Balakrishnan Rajendran, on Apr 29, 2020
   */
  onLogoutResponse(responseObj) {
    if (responseObj && localStorage.getItem('token')) {
      this.profile.logout().subscribe((result: any) => {
        localStorage.removeItem('token');
        localStorage.removeItem('profile');
        localStorage.removeItem('session');
        localStorage.removeItem('missionaryGAUId');
        localStorage.removeItem('isMissionaryUser');
        localStorage.removeItem('isHQUser');
        localStorage.removeItem('isGAUEditor');
        localStorage.removeItem('isFinanceUser');
        localStorage.removeItem('loginProvider');
        localStorage.removeItem('userId');
        localStorage.removeItem('selectedAccount');
        this.profile.currentProfile = new User();
        var sourceApp = localStorage.getItem('sourceApp');
        localStorage.clear();
        localStorage.setItem('sourceApp',sourceApp);
        this.profile.logout();
        window.location.pathname = '/';
      }, (error: HttpErrorResponse) => {
        console.log('Error:', error);
      });
    }
    this.profile.profileUpdate();
  }

  /**
   * This function is used to prepare the logged-in user details.
   */
  setAfterLoginData(data, loginObj) {
    console.log(loginObj)
    const gettingDateOfBirth = data.Birthdate.split('-');
    return {
      AccountId: data.AccountId,
      IntacctID__c: data.IntacctID__c,
      FirstName: data.FirstName,
      LastName: data.LastName,
      photoURL: loginObj.photoURL,
      thumbnailURL: loginObj.thumbnailURL,
      Email: data.Email,
      Birthdate: data.Birthdate,
      MobilePhone: data.MobilePhone,
      HomePhone: data.HomePhone,
      WorkPhone: data.WorkPhone,
      BillingStreet_1: data.BillingStreet_1,
      BillingStreet_2: data.BillingStreet_2,
      BillingStreet_3: data.BillingStreet_3,
      BillingCity: data.BillingCity,
      BillingState: data.BillingState,
      BillingPostalCode: data.BillingPostalCode,
      BillingCountry: data.BillingCountry,
      ShippingStreet_1: data.ShippingStreet_1,
      ShippingStreet_2: data.ShippingStreet_2,
      ShippingStreet_3: data.ShippingStreet_3,
      ShippingCity: data.ShippingCity,
      ShippingState: data.ShippingState,
      ShippingPostalCode: data.ShippingPostalCode,
      ShippingCountry: data.ShippingCountry,
      year: gettingDateOfBirth[0],
      month: gettingDateOfBirth[1],
      date: gettingDateOfBirth[2],
      UID: loginObj.UID
    }
  }

}
